import { render, staticRenderFns } from "./StateSpecificPage.vue?vue&type=template&id=223ca622&scoped=true&"
import script from "./StateSpecificPage.vue?vue&type=script&lang=js&"
export * from "./StateSpecificPage.vue?vue&type=script&lang=js&"
import style0 from "./StateSpecificPage.vue?vue&type=style&index=0&id=223ca622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ca622",
  null
  
)

export default component.exports